import { MeasurementUnit } from '../types/index.ts';

// Remembers the user's preferred measurement unit (in / cm) across page
// navigation and reloads, so Search and Box Management don't reset to 'in'.
const PREFERRED_UNIT_KEY = 'killian_preferred_unit';

export const getPreferredUnit = (): MeasurementUnit => {
  try {
    return localStorage.getItem(PREFERRED_UNIT_KEY) === 'cm' ? 'cm' : 'in';
  } catch {
    return 'in';
  }
};

export const setPreferredUnit = (unit: MeasurementUnit): void => {
  if (unit !== 'in' && unit !== 'cm') return;
  try {
    localStorage.setItem(PREFERRED_UNIT_KEY, unit);
  } catch {
    /* storage unavailable: ignore, the app keeps working */
  }
};

// Safety margin (clearance) subtracted from each box dimension in the packaging
// calculation. Stored canonically in inches; default 0 (a product exactly the
// size of the box fits). The UI enters/displays it in the selected unit.
const MARGIN_INCHES_KEY = 'killian_margin_inches';

export const getMarginInches = (): number => {
  try {
    const raw = localStorage.getItem(MARGIN_INCHES_KEY);
    const value = parseFloat(raw ?? '');
    return Number.isFinite(value) && value >= 0 ? value : 0;
  } catch {
    return 0;
  }
};

export const setMarginInches = (value: number): void => {
  if (!Number.isFinite(value) || value < 0) return;
  try {
    localStorage.setItem(MARGIN_INCHES_KEY, String(value));
  } catch {
    /* storage unavailable: ignore, the app keeps working */
  }
};
